import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSoftware = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 12,
	viewBox: "0 0 14 12",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.9275 0.763424L7.76333 0.472382L7.61781 1.05447L5.21781 10.6545L5.07229 11.2366L6.23646 11.5276L6.38198 10.9455L8.78198 1.34551L8.9275 0.763424ZM4.48842 3.36014L4.06416 3.78441L1.84842 6.00014L4.06416 8.21588L4.48842 8.64014L3.6399 9.48867L3.21563 9.06441L0.575631 6.42441L0.151367 6.00014L0.575631 5.57588L3.21563 2.93588L3.6399 2.51162L4.48842 3.36014ZM10.3599 2.51162L10.7841 2.93588L13.4241 5.57588L13.8484 6.00014L13.4241 6.42441L10.7841 9.06441L10.3599 9.48867L9.51133 8.64014L9.93559 8.21588L12.1513 6.00014L9.93559 3.78441L9.51133 3.36014L10.3599 2.51162Z"
	})
});
export default SvgSoftware;
